/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentLocateOperationStatuses } from './equipment-locate-operation-statuses';


export interface EquipmentLocateOperationResponse { 
    id?: string;
    status?: EquipmentLocateOperationStatuses;
    requestedOn?: boolean;
    requestedAtUtc?: string;
    commandDispatchedAtUtc?: string | null;
    deviceRequestSentAtUtc?: string | null;
    telemetryConfirmedAtUtc?: string | null;
    failedAtUtc?: string | null;
    staleAtUtc?: string | null;
    failureReason?: string | null;
    isOverdue?: boolean;
}



